import DropdownSelect from "../../components/dropdown/Dropdown";
import ModalBasic from "../component/ModalBasic";
import React, { useEffect, useState } from "react";

const CommitteeMembers = (props) => {
    return (
        <div className="grid grid-cols-12 gap-10  w-full items-center pt-7 text-white py-4 md:px-15 px-4 w-[100%]">
            <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                            className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                            htmlFor="default"
                        >
                            Full Name 
                        </label>
                        <div className="flex">
                        <div className="w-[130px] ">
                            <DropdownSelect
                                drpIdentity={"SalutationName"}
                                optionArray={props.salutationDropdown}
                                value={props.committeeMemberDetails.salutationId}
                                setFilterParameters={(id, drpIdentity) => props.setFilterParameters(id, drpIdentity)}
                            />
                        </div>
                        <input
                            id="default"
                            className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                            type="text"
                            name="name"
                            value={props.committeeMemberDetails.name}
                            onChange={(event) => props.handleChange(event)}
                        />
                        </div>
                    </div>
                </div>
            </div>
            <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                            className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                            htmlFor="default"
                        >
                            Email
                        </label>
                        <input
                            id="default"
                            className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                            type="text"
                            name="email"
                            value={props.committeeMemberDetails.email}
                            onChange={(event) => props.handleChange(event)}
                        />
                        <div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <button className={`py-2 w-[250px] btn btn-lighblue text-lg rounded-md text-white font-bold `}
                            onClick={() => props.addEditCommitteeMember()}
                        >
                            {props.committeeMemberDetails.committeeMemberId > 0 ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </div>
            {/* <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12 ml-auto">
                        <button className={`py-2 w-[250px] btn btn-red text-lg rounded-md text-white font-bold `}
                            onClick={() => props.deleteCommitteeMemberById(props.committeeMemberDetails.committeeMemberId)}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div> */}
        </div>
    );
};
export default CommitteeMembers;
